import { select, put, call } from 'redux-saga/effects';
import _some from 'lodash/some.js';
import { quickViewPricingApi } from '../../api/quickViewPricingApi';
import { thdStoreInfoSelector } from '../../selectors/thdStoreInfo/thdStoreInfoSelector';
import { configuratorSelector } from '../../selectors/configurator/configuratorSelector';
import { updateQuickViewPricing } from '../../actions/quickView';

export default function* getQuickViewOptionPricing() {
  // We should not invoke quickview pricing during prerender
  if (window.prerender) {
    return;
  }

  const {
    storeNumber,
  } = yield select(thdStoreInfoSelector);

  // We should not invoke quickview pricing if store info is not yet ready (race condition?)
  if (!storeNumber) {
    return;
  }
  const {
    productInfo: { productId },
    options,
  } = yield select(configuratorSelector);

  // We should not invoke quickview pricing if none on the options have the quickview tag
  if (!_some(options, option => option.tags && option.tags.indexOf('quickview') >= 0)) {
    return;
  }

  const params = { storeId: storeNumber, productId };
  const pricing = yield call(quickViewPricingApi, params);
  yield put(updateQuickViewPricing(pricing));
}
